import { getUser, NAME_SESSION } from '@shared/helpers/auth';

// Función utilitaria para validar expiración del token
const checkTokenExpired = expiration => {
  if (!expiration) return true;
  const now = Math.floor(Date.now() / 1000);
  return now >= expiration;
};

// Traemos los datos del usuario desde localStorage o sesión
const userData = getUser();
const initialState = {
  userToken: userData?.access_token || '',
  isTokenExpired: checkTokenExpired(userData?.expiration),
  user: userData?.user || {},
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ON_USER_LOGIN': {
      const tokenExpired = checkTokenExpired(action.payload.expiration);
      return {
        userToken: action.payload.access_token,
        isTokenExpired: tokenExpired,
        user: action.payload.user,
      };
    }

    case 'REFRESH_TOKEN': {
      const tokenExpired = checkTokenExpired(action.payload.expiration);
      return {
        ...state,
        userToken: action.payload.access_token,
        isTokenExpired: tokenExpired,
        refresh_token: action.payload.refresh_token,
      };
    }

    case 'ON_USER_LOGOUT':
      localStorage.removeItem(NAME_SESSION);
      return {
        userToken: '',
        isTokenExpired: true,
        user: {},
      };

    default:
      return state;
  }
};

export default userReducer;
